import { Injectable } from '@angular/core';
import { InvoiceService } from '../../../../invoice/service/data/invoice.service';
import { InvoiceListService } from '../../../../invoice/service/data/invoice-list.service';

// This service is used to fetch invoices for a specific rent invoicing order,
// and ensures that the rentInvoicingOrderId is always included in the filter when fetching invoices for this context.
@Injectable()
export class RentInvoicingOrderInvoiceService extends InvoiceListService {
  prepareFilter(filter: any): any {
    let filterModel = {
      selectedFields: ['rentInvoicingOrderId'],
      rentInvoicingOrderId: filter.rentInvoicingOrderId,
      ignoreSaveOnLoad: true,
      orderBy: filter.orderBy,
      descending: filter.descending,
    };
    return super.prepareFilter(filterModel);
  }
}
